import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllPart() {
  try {
    let res = await client.get("/part");

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function fetchAllRack() {
  try {
    let res = await client.get("/rack");

    return res.data.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function fetchOnePart(id) {
  try {
    let res = await client.get("/part/part_id/" + id);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function createPart(part_number, name, rack, standart_stock) {
  try {
    let res = await client.post("/part/create", {
      part_number: part_number,
      name: name,
      rack_id: rack,
      standart_stock: standart_stock,
    });

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function updatePart(id, name, standart_stock, rack_name) {
  try {
    let res = await client.post("/part/update", {
      id: id,
      name: name,
      standart_stock: standart_stock,
      rack_id: rack_name,
    });

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function exportPart() {
  try {
    let res = await client.get("/part/download", {
      responseType: "blob",
    });

    // Extract filename from content-disposition header
    const contentDisposition = res.headers["content-disposition"];
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(contentDisposition);
    const filename =
      matches && matches[1]
        ? matches[1].replace(/['"]/g, "")
        : "data-part.xlsx";

    // Create a temporary URL for the file
    const url = window.URL.createObjectURL(new Blob([res.data]));

    // Create a link and click it to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename); // Set filename
    document.body.appendChild(link);
    link.click();

    // Clean up the URL object after the download
    window.URL.revokeObjectURL(url);
  } catch (err) {
    throw ErrorException(err);
  }
}

async function importPart(file) {
  const form = new FormData();
  form.append("file", file);

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  try {
    let res = await client.post("/part/upload", form, config);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function deletePart(id) {
  try {
    let res = await client.delete("/part/part_id/" + id);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

export {
  fetchAllPart,
  fetchAllRack,
  fetchOnePart,
  createPart,
  updatePart,
  exportPart,
  importPart,
  deletePart,
};
